import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Text from '../Text';
import { PillButton } from './PillButton';

export const SplitPillButton = ({
  iconClass,
  leftText,
  rightText,
  onClick,
}) => {
  return (
    <Button variant="grey" mode="outline" onClick={onClick}>
      <LeftContainer>
        <Icon className={iconClass} />
        <Text color="black.100" variant="subtitle2">
          {leftText}
        </Text>
      </LeftContainer>
      <RightContainer>
        <Text color="black.60" variant="subtitle2">
          {rightText}
        </Text>
      </RightContainer>
    </Button>
  );
};

const Button = styled(PillButton)`
  padding: 0px;
`;

const LeftContainer = styled.div`
  border-right: 1px solid ${themeGet('colors.black.60')};
  border-radius: 32px;
  padding: 8px 12px;
`;

const RightContainer = styled.div`
  padding-right: 12px;
  padding-left: 5px;
`;

const Icon = styled.i`
  margin-right: 6px;
  color: ${themeGet('colors.black.100')};
`;
